import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { CustomerService } from '../../shareModule/services/customer.service';

@Component({
    selector: 'app-edit-category-faq',
    templateUrl: './edit-category-faq.component.html',
    styleUrls: ['./edit-category-faq.component.scss'],
})
export class EditCategoryFaqComponent implements OnInit {
    constructor(
        public modal: NgbActiveModal,
        private cdr: ChangeDetectorRef,
        private toastr: ToastrService,
        private auth: AuthServiceService,
        private customerService: CustomerService
    ) { }

    ngOnInit() {
        console.log('EditCategoryFaqComponent ngOnInit called');
        console.log('Initial values:', { filter: this.filter, filterId: this.filterId });
        this.loadExistingFaqData();
    }

    // ─────────── Private fields ───────────
    private _question: string[] = ['', '', '', '', ''];
    private _answer: string[] = ['', '', '', '', ''];
    private _attachedProductSlug: string[] = ['', '', '', '', ''];
    private _filter: string = '';
    private _filterId: number = 0;

    // Product search arrays
    public searchedProductsOne: any[] = [];
    public searchedProductsTwo: any[] = [];
    public searchedProductsThree: any[] = [];
    public searchedProductsFour: any[] = [];
    public searchedProductsFive: any[] = [];

    // ─────────── Inputs (Getters/Setters with detectChanges) ───────────
    @Input() set question(v: string[]) { this._question = v; this.cdr.detectChanges(); }
    get question() { return this._question; }

    @Input() set answer(v: string[]) { this._answer = v; this.cdr.detectChanges(); }
    get answer() { return this._answer; }

    @Input() set attachedProductSlug(v: string[]) { this._attachedProductSlug = v; this.cdr.detectChanges(); }
    get attachedProductSlug() { return this._attachedProductSlug; }

    @Input() set filter(v: string) {
        console.log('Filter input set to:', v);
        this._filter = v;
        this.cdr.detectChanges();
        if (v && this._filterId) {
            console.log('Filter and filterId both available, loading FAQ data');
            this.loadExistingFaqData();
        }
    }
    get filter() { return this._filter; }

    @Input() set filterId(v: number) {
        console.log('FilterId input set to:', v);
        this._filterId = v;
        this.cdr.detectChanges();
        if (v && this._filter) {
            console.log('FilterId and filter both available, loading FAQ data');
            this.loadExistingFaqData();
        }
    }
    get filterId() { return this._filterId; }

    // ─────────── Methods ───────────
    loadExistingFaqData() {
        console.log('loadExistingFaqData called with:', { filter: this.filter, filterId: this.filterId });

        if (!this.filter || !this.filterId) {
            console.log('Missing filter or filterId, cannot load FAQ data');
            return;
        }

        const params = {
            filter: this.filter,
            filterId: this.filterId
        };

        this.customerService.getMemberShopCategoriesFAQ(params).subscribe({
            next: (data) => {
                if (data && data.body) {
                    const faqData = data.body;

                    // Update questions array
                    if (faqData.question && Array.isArray(faqData.question)) {
                        this._question = [...faqData.question];
                        // Ensure we have exactly 5 elements
                        while (this._question.length < 5) {
                            this._question.push('');
                        }
                        this._question = this._question.slice(0, 5);
                    }

                    // Update answers array
                    if (faqData.answer && Array.isArray(faqData.answer)) {
                        this._answer = [...faqData.answer];
                        // Ensure we have exactly 5 elements
                        while (this._answer.length < 5) {
                            this._answer.push('');
                        }
                        this._answer = this._answer.slice(0, 5);
                    }

                    // Update attached product slugs array
                    if (faqData.attachedProductSlug && Array.isArray(faqData.attachedProductSlug)) {
                        this._attachedProductSlug = [...faqData.attachedProductSlug];
                        // Ensure we have exactly 5 elements
                        while (this._attachedProductSlug.length < 5) {
                            this._attachedProductSlug.push('');
                        }
                        this._attachedProductSlug = this._attachedProductSlug.slice(0, 5);
                    }

                    this.cdr.detectChanges();
                    console.log('FAQ data loaded successfully');
                } else {
                    console.log('No FAQ data found in response');
                }
            },
            error: (err) => {
                console.error('Error loading FAQ data:', err);
                // Don't show error toast for missing data, as it might be the first time creating FAQ
            }
        });
    }

    saveFaq() {
        const faqData = {
            question: this.question,
            answer: this.answer,
            attachedProductSlug: this.attachedProductSlug,
            filter: this.filter,
            filterId: this.filterId,
        };

        this.customerService.addMemberShopCategoriesFAQ(faqData).subscribe({
            next: (data) => {
                this.toastr.success(data.message);
                this.modal.close(faqData);
            },
            error: (err) => {
                this.toastr.error(err.message);
            }
        });
    }

    cancel() {
        this.modal.dismiss();
    }

    // Helper methods for array manipulation
    updateQuestion(index: number, value: string) {
        this.question[index] = value;
        this.cdr.detectChanges();
    }

    updateAnswer(index: number, value: string) {
        this.answer[index] = value;
        this.cdr.detectChanges();
    }

    updateAttachedProductSlug(index: number, value: string) {
        this.attachedProductSlug[index] = value;
        this.cdr.detectChanges();
    }

    // Product search methods
    public searchProducts(searchText: string, targetNumber: number) {
        this.customerService
            .getMemberShopProductList({ search: searchText, limit: 15 })
            .subscribe({
                next: (data) => {
                    switch (targetNumber) {
                        case 1: {
                            this.searchedProductsOne = data.body.data;
                            break;
                        }
                        case 2: {
                            this.searchedProductsTwo = data.body.data;
                            break;
                        }
                        case 3: {
                            this.searchedProductsThree = data.body.data;
                            break;
                        }
                        case 4: {
                            this.searchedProductsFour = data.body.data;
                            break;
                        }
                        case 5: {
                            this.searchedProductsFive = data.body.data;
                            break;
                        }
                    }
                },
                error: (err) => {
                    console.error(err);
                    this.toastr.error('Error loading products');
                },
            });
    }

    public setAttachedProductOfFaq(slug: string, targetNumber: number) {
        switch (targetNumber) {
            case 1: {
                this.attachedProductSlug[0] = slug;
                this.searchedProductsOne = [];
                break;
            }
            case 2: {
                this.attachedProductSlug[1] = slug;
                this.searchedProductsTwo = [];
                break;
            }
            case 3: {
                this.attachedProductSlug[2] = slug;
                this.searchedProductsThree = [];
                break;
            }
            case 4: {
                this.attachedProductSlug[3] = slug;
                this.searchedProductsFour = [];
                break;
            }
            case 5: {
                this.attachedProductSlug[4] = slug;
                this.searchedProductsFive = [];
                break;
            }
        }
        this.cdr.detectChanges();
        this.toastr.success("Product Attached");
    }

    // Helper methods for template
    public getSearchedProducts(targetNumber: number): any[] {
        switch (targetNumber) {
            case 1: return this.searchedProductsOne;
            case 2: return this.searchedProductsTwo;
            case 3: return this.searchedProductsThree;
            case 4: return this.searchedProductsFour;
            case 5: return this.searchedProductsFive;
            default: return [];
        }
    }

    public clearSearchedProducts(targetNumber: number) {
        switch (targetNumber) {
            case 1: this.searchedProductsOne = []; break;
            case 2: this.searchedProductsTwo = []; break;
            case 3: this.searchedProductsThree = []; break;
            case 4: this.searchedProductsFour = []; break;
            case 5: this.searchedProductsFive = []; break;
        }
        this.cdr.detectChanges();
    }
}
